import styled from 'styled-components';

export const MyBenefitsListWrap = styled.ul(
	({ theme: { down, breakpoints } }) => `
		display: flex;
		justify-content: space-between;
		width: 100%;
		li{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 345px; 
		}
		${down(breakpoints.md)} {
			padding-left: 16px;
			li{
				margin-right: 40px;
			}
			overflow-x: scroll;
			&.container {
				-ms-overflow-style: none; /* for Internet Explorer, Edge */
				scrollbar-width: none; /* for Firefox */
				overflow-y: scroll;
			::-webkit-scrollbar {
				-webkit-appearance: none;
				display: none;
			}
		}
	`
);

export const QrCodeText = styled.div`
	font-weight: 900;
	font-size: 22px;
	padding: 32px 0 16px 0;
`;
